import React, { forwardRef, ReactNode } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { MessageStatusIcon } from './MessageStatusIcon';
import { MessageStatusType } from './types';
import { FlexGrid, FlexGridColumn } from '../FlexGrid';
import { PaddingBox } from '../PaddingBox';
import { Close } from '../Icons/Close';

type MessageProps = {
	children: ReactNode;
	hasStatusIcon?: boolean;
	statusIconTop?: boolean;
	hasCloseButton?: boolean;
	status?: MessageStatusType;
	className?: string;
	onClose?: () => void;
	dataTestId?: string;
};

export const Message = forwardRef<HTMLDivElement, MessageProps>(
	(
		{
			children,
			hasStatusIcon = true,
			statusIconTop = true,
			hasCloseButton = false,
			status,
			className: classNameFromProps,
			onClose,
			dataTestId,
		},
		ref,
	) => {
		const componentClasses = classNames(classNameFromProps, classes.message, classes[`message_${status}`]);

		return (
			<PaddingBox
				className={componentClasses}
				tiny
			>
				<FlexGrid
					spaceBetween
					center
					gap='tiny'
					data-testid={dataTestId}
					ref={ref}
				>
					{hasStatusIcon && status && (
						<FlexGridColumn vrStart={statusIconTop}>
							<FlexGrid
								center
								hrCenter
							>
								<MessageStatusIcon status={status} />
							</FlexGrid>
						</FlexGridColumn>
					)}

					<FlexGridColumn
						wrappedText
						basis100
					>
						{children}
					</FlexGridColumn>

					{hasCloseButton && (
						<FlexGridColumn noShrink>
							<button
								type='button'
								className={classes.closeButton}
								onClick={onClose}
							>
								<PaddingBox scanty>
									<Close
										width='8px'
										height='8px'
									/>
								</PaddingBox>
							</button>
						</FlexGridColumn>
					)}
				</FlexGrid>
			</PaddingBox>
		);
	},
);

Message.displayName = 'Message';
